import React from "react";

import { useTheme } from "@mui/material/styles";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import SmsRoundedIcon from "@mui/icons-material/SmsRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import VerifiedIcon from "@mui/icons-material/Verified";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeIcon from "@mui/icons-material/Mode";
import CopyAllOutlinedIcon from "@mui/icons-material/CopyAllOutlined";
import HelpIcon from "@mui/icons-material/Help";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import BuildRoundedIcon from "@mui/icons-material/BuildRounded";
import PaletteIcon from "@mui/icons-material/Palette";
import TableRowsIcon from "@mui/icons-material/TableRows";
import SmartButtonOutlinedIcon from "@mui/icons-material/SmartButtonOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import ErrorIcon from "@mui/icons-material/Error";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import ElectricalServicesRoundedIcon from "@mui/icons-material/ElectricalServicesRounded";
import PowerRoundedIcon from "@mui/icons-material/PowerRounded";
import PowerOffRoundedIcon from "@mui/icons-material/PowerOffRounded";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventIcon from "@mui/icons-material/Event";
import BadgeIcon from "@mui/icons-material/Badge";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import WebhookIcon from "@mui/icons-material/Webhook";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PixIcon from "@mui/icons-material/Pix";
import AddCardIcon from "@mui/icons-material/AddCard";
import FastForwardIcon from "@mui/icons-material/FastForward";
import ChecklistIcon from "@mui/icons-material/Checklist";
import EditIcon from "@mui/icons-material/Edit";
import GoogleIcon from "@mui/icons-material/Google";
import { Business } from "@mui/icons-material";

const StatusIcon = ({ status, width, height, color }) => {
  const theme = useTheme();

  if (color === undefined || color === null) {
    color = theme.palette.custom.purple[800];
  }

  switch (status) {
    case "Google":
      return (
        <GoogleIcon style={{ fill: color, width: width, height: height }} />
      );
    case "ERP":
      return <Business style={{ fill: color, width: width, height: height }} />;
    case "AddCard":
      return (
        <AddCardIcon style={{ fill: color, width: width, height: height }} />
      );
    case "Pix":
      return <PixIcon style={{ fill: color, width: width, height: height }} />;
    case "Cobrança":
      return (
        <PaidOutlinedIcon
          style={{ fill: color, width: width, height: height }}
        />
      );
    case "Close":
      return (
        <CloseIcon style={{ fill: color, width: width, height: height }} />
      );
    case "Star":
      return <StarIcon style={{ fill: color, fontSize: width }} />;
    case "WhatsApp":
      return <WhatsAppIcon style={{ fill: color, fontSize: width }} />;
    case "WhatsAppWEB":
      return <WhatsAppIcon style={{ fill: color, fontSize: width }} />;
    case "WhatsAppAPI":
      return <VerifiedIcon style={{ fill: color, fontSize: width }} />;
    case "codeChat":
      return <WhatsAppIcon style={{ fill: color, fontSize: width }} />;
    case "whatsAppOfficial":
      return <VerifiedIcon style={{ fill: color, fontSize: width }} />;
    case "WhatsApp Business":
      return <VerifiedIcon style={{ fill: color, fontSize: width }} />;
    case "SMS":
      return <SmsRoundedIcon style={{ fill: color, fontSize: width }} />;
    case "Email":
      return <EmailRoundedIcon style={{ fill: color, fontSize: width }} />;
    case "E-mail":
      return <EmailRoundedIcon style={{ fill: color, fontSize: width }} />;
    case "email":
      return <EmailRoundedIcon style={{ fill: color, fontSize: width }} />;
    case "ArrowBottom":
      return <ArrowDropDownIcon style={{ fill: color, fontSize: width }} />;
    case "ArrowTop":
      return <ArrowDropUpIcon style={{ fill: color, fontSize: width }} />;
    case "Delete":
      return <DeleteIcon style={{ fill: color, fontSize: width }} />;
    case "Edit":
      return <ModeIcon style={{ fill: color, fontSize: width }} />;
    case "Duplicate":
      return <CopyAllOutlinedIcon style={{ fill: color, fontSize: width }} />;
    case "Help":
      return <HelpIcon style={{ fill: color, fontSize: width }} />;
    case "Search":
      return <SearchOutlinedIcon style={{ fill: color, fontSize: width }} />;
    case "Palette":
      return <PaletteIcon style={{ fill: color, fontSize: width }} />;
    case "Table":
      return <TableRowsIcon style={{ fill: color, fontSize: width }} />;
    case "Label":
      return (
        <SmartButtonOutlinedIcon style={{ fill: color, fontSize: width }} />
      );
    case "Button":
      return (
        <IndeterminateCheckBoxOutlinedIcon
          style={{ fill: color, fontSize: width }}
        />
      );
    case "Emoji":
      return <EmojiEmotionsIcon style={{ fill: color, fontSize: width }} />;
    case "Letter":
      return <FormatColorTextIcon style={{ fill: color, fontSize: width }} />;
    case "Campanha":
      return <CampaignRoundedIcon style={{ fill: color, fontSize: width }} />;
    case "Suporte":
      return <ContactSupportIcon style={{ fill: color, fontSize: width }} />;
    case "Sheets":
      return <TableRowsIcon style={{ fill: color, fontSize: width }} />;
    case "Alert":
      return <ErrorIcon style={{ fill: color, fontSize: width }} />;
    case "Electrical":
      return (
        <ElectricalServicesRoundedIcon
          style={{ fill: color, fontSize: width }}
        />
      );
    case "Power":
      return <PowerRoundedIcon style={{ fill: color, fontSize: width }} />;
    case "AlarmOn":
      return <AlarmOnIcon style={{ fill: color, fontSize: width }} />;
    case "AlarmOff":
      return <AlarmOffIcon style={{ fill: color, fontSize: width }} />;
    case "Plus":
      return <AddIcon style={{ fill: color, width: width, height: height }} />;
    case "Minus":
      return <RemoveIcon style={{ fill: color, width: width, height: height }} />;
    case "PowerOff":
      return <PowerOffRoundedIcon style={{ fill: color, fontSize: width }} />;
    case "FastForward":
      return <FastForwardIcon style={{ fill: color, fontSize: width }} />;
    case "Checklist":
      return <ChecklistIcon style={{ fill: color, fontSize: width }} />;
    case "Pen":
      return <EditIcon style={{ fill: color, fontSize: width }} />;

    case "Marketing":
      return <CampaignRoundedIcon style={{ fill: color, width: width, height: height }} />;
    case "Services":
      return <BuildRoundedIcon style={{ fill: color, width: width, height: height }} />;
    case "Financeiro":
      return <PaidOutlinedIcon style={{ fill: color, width: width, height: height }} />;
    case "Check":
      return (
        <CheckCircleOutlineIcon style={{ fill: color, fontSize: width }} />
      );
    case "PERSON":
      return (
        <PersonIcon style={{ fill: color, width: width, height: height }} />
      );
    case "ORGANIZATION":
      return (
        <BusinessIcon style={{ fill: color, width: width, height: height }} />
      );
    case "LOCATION":
      return (
        <LocationOnIcon style={{ fill: color, width: width, height: height }} />
      );
    case "DATE":
      return (
        <EventIcon style={{ fill: color, width: width, height: height }} />
      );
    case "EVENT":
      return (
        <EventIcon style={{ fill: color, width: width, height: height }} />
      );
    case "TITLE":
      return (
        <BadgeIcon style={{ fill: color, width: width, height: height }} />
      );
    case "QUANTITY":
      return <AddIcon style={{ fill: color, width: width, height: height }} />;
    case "OTHER":
      return (
        <MoreHorizIcon style={{ fill: color, width: width, height: height }} />
      );
    case "WEBHOOK":
      return (
        <WebhookIcon style={{ fill: color, width: width, height: height }} />
      );
    case "API":
      return (
        <WebhookIcon style={{ fill: color, width: width, height: height }} />
      );
    case "Google planilhas":
      return (
        <GoogleIcon style={{ fill: color, width: width, height: height }} />
      );
    case "Newspaper":
      return (
        <NewspaperIcon style={{ fill: color, width: width, height: height }} />
      );
    case "Excel":
      return (
        <NewspaperIcon style={{ fill: color, width: width, height: height }} />
      );
    default:
      return null;
  }
};
export default StatusIcon;
